<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";

//import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const emit = defineEmits(["editRegist", "editCancel"]);

const hasSubmitted = ref(false);
const isUserId = ref(false);
const isName = ref(false);
const isPublicationOrder = ref(false);
const isRoles = ref(false);

const userId = ref(props.dialogItem.userId);
const name = ref(props.dialogItem.name);
const journalistName = ref(props.dialogItem.journalistName);
const publicationOrder = ref(props.dialogItem.publicationOrder);
const invalid = ref(props.dialogItem.invalid);
const roles = ref(props.dialogItem.roles);

//ダイアログ登録処理

const props = defineProps({
  roles: {
    type: Array,
    default: () => [],
  },
  dialogItem: {
    type: Object,
  },
});

const dialogClear = (event) => {
  console.log("ダイアログのクリア");
  console.log(event);
  console.log("あ");
  isUserId.value = false;
  isName.value = false;
  isPublicationOrder.value = false;
  isRoles.value = false;

  userId.value = props.dialogItem.userId;
  name.value = props.dialogItem.name;
  journalistName.value = props.dialogItem.journalistName;
  publicationOrder.value = props.dialogItem.publicationOrder;
  invalid.value = props.dialogItem.invalid;
  roles.value = props.dialogItem.roles;
};

onMounted(() => {
  let myModalEl = document.getElementById("exampleModal");
  myModalEl.addEventListener("show.bs.modal", dialogClear);
  console.log("い");
});

onBeforeUnmount(() => {
  let myModalEl = document.getElementById("exampleModal");
  myModalEl.removeEventListener("show.bs.modal", dialogClear);
  console.log("う");
});

const checkUser = async () => {
  hasSubmitted.value = true;
  // 各バリデーションのフラグを初期化
  isUserId.value = false;
  isName.value = false;
  isPublicationOrder.value = false;
  isRoles.value = false;

  if (!userId.value) {
    isUserId.value = true;
    console.log(userId.value);
  }
  if (!name.value) {
    console.log(name.value);
    isName.value = true;
  }
  if (!publicationOrder.value) {
    console.log(publicationOrder.value);
    isPublicationOrder.value = true;
  }
  if (roles.value.length == 0) {
    console.log(roles);
    isRoles.value = true;
  }
  // 入力エラーがある場合は処理を止める
  if (
    isUserId.value ||
    isName.value ||
    isPublicationOrder.value ||
    isRoles.value
  ) {
    console.error("入力内容にエラーがあります");
    // エラー処理
    return;
  }
  const data = {
    id: props.dialogItem.id,
    userId: userId.value,
    name: name.value,
    journalistName: journalistName.value,
    publicationOrder: publicationOrder.value,
    invalid: invalid.value,
    roles: roles.value,
  };

  emit("editRegist", data);
};
</script>

<template>
  <!-- Modal -->
  <div
    class="modal fade"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">登録内容確認</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="userIdInput" class="form-label">ユーザーID</label>
              <input
                type="text"
                class="form-control"
                v-model="userId"
                maxlength="128"
              />
              <p class="error-message text-start" v-if="isUserId">
                ユーザーIDは必須です。<br />4文字以上入力してください。
              </p>
            </div>
            <div class="col-md-6">
              <label for="nameInput" class="form-label">氏名</label>
              <input
                type="text"
                class="form-control"
                v-model="name"
                maxlength="20"
              />
              <p class="error-message text-start">
                <span v-if="isName">氏名は必須です</span>
              </p>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="reporterNameInput" class="form-label">記者名</label>
              <input
                type="text"
                class="form-control"
                v-model="journalistName"
                maxlength="6"
              />
            </div>
            <div class="col-md-6">
              <label for="priorityInput" class="form-label">掲載優先順</label>
              <input
                type="number"
                class="form-control"
                v-model="publicationOrder"
                min="1"
                max="99"
                maxlength="2"
                oninput="javascript: this.value = this.value.slice(0, 2)"
              />
              <p class="error-message text-start">
                <span v-if="isPublicationOrder">掲載優先順は必須です</span>
              </p>
            </div>
          </div>
          <div class="col-md-6">
            <label for="invalidFlag" class="form-label">無効フラグ</label>
            <input id="invalidFlag" type="checkbox" v-model="invalid" />
          </div>
          <div class="col-md-6">
            <label for="roleInput" class="form-label">役割</label>
            <div class="checkbox-group">
              <div
                v-for="role in props.roles"
                :key="role.id"
                class="checkbox-item"
              >
                <input
                  :id="`role-${role.id}`"
                  type="checkbox"
                  :value="role.id"
                  v-model="roles"
                />
                <label :for="`role-${role.id}`" class="checkbox-label">{{
                  role.name
                }}</label>
              </div>
            </div>
            <p class="error-message text-start">
              <span v-if="isRoles">役割は必須です</span>
            </p>
          </div>
          <div class="d-flex flex-row body_message">
            <div class="col-md-6"></div>
          </div>
          <div class="mb-3"></div>
        </div>
        <div class="modal-footer">
          <button class="submit_button" @click="checkUser()">登録</button>
          <button
            class="submit_button"
            data-bs-dismiss="modal"
            @click="$emit('editCancel')"
          >
            キャンセル
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.checkbox-group {
  display: flex; /* Flex コンテナを使用して横並びに配置 */
  align-items: center; /* 垂直方向の中央寄せ */
}

.checkbox-item {
  margin-right: 10px; /* チェックボックス間の余白を調整 */
  display: flex; /* チェックボックスとラベルを横並びにするために Flex コンテナを使用 */
  align-items: center; /* 垂直方向の中央寄せ */
}
.checkbox-label {
  white-space: nowrap; /* テキストが改行されないようにする */
  margin-left: 5px; /* チェックボックスとテキストの間隔 */
}

@media (prefers-color-scheme: dark) {
  .modal-content {
    background-color: #333; /* ダークモードの背景色 */
    color: #fff; /* ダークモードのテキストカラー */
  }
  .error-message {
    color: #ff6b6b; /* ダークモードのエラーメッセージカラー */
  }
  input,
  input:focus {
    color: #fff; /* 好みの色を指定してください */
  }
}
/* 必要なスタイルをここに追加 
  this.$emit('editRegist', props.dialogItem.id, {'userId': props.dialogItem.userId, 'name':props.dialogItem.name, 'journalistName':props.dialogItem.journalistName,'publicationOrder':props.dialogItem.publicationOrder,'invalid':props.dialogItem.invalid,'roles':props.dialogItem.roles})*/
</style>
